import React, { useState, useEffect } from "react";
// import { toAbsoluteUrl } from "@ellantec/pearlcore_config/dist/_pearl/_helpers";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";

export function EmailVerificationExpired(props) {
  // const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;
  // const webConfigData = useSelector(state => state.webConfig);
  const history = useNavigate();

  const [logoName, setLogoName] = useState(null);
  const [appName, setAppName] = useState(null);
  const { intl, firm } = props;
  // const location = useLocation();

  useEffect(() => {
    let data = localStorage.getItem("persist:config");
    if (data) {
      // let config = JSON.parse(data);
      // setLogoName(JSON.parse(config.config).logo);
      // setAppName(config.name)
    }
  }, []);

  function resendLink() {
    history("/users/user-lists/default-card");
  }
  return (
    <>
      <div className="d-flex flex-column flex-root bg-white">
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Login*/}
          <div
            className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
            style={
              {
                // backgroundImage: `url(${toAbsoluteUrl("/media/bg/progress-hd.png")})`,
              }
            }
          >
            <div className="d-flex flex-column flex-column-fluid text-center p-10 py-lg-20 justify-content-center">
              <div className="pt-lg-10 mr-t-15">
                {/* <img
                  alt="Logo"
                  className="h-50px mb-10"
                  // src={toAbsoluteUrl(webConfigData.config.logo)}
                /> */}
              </div>
              <div className="pt-lg-10 mr-b-20">
                <img
                  src={
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Icons8_flat_expired.svg/1024px-Icons8_flat_expired.svg.png"
                  }
                  style={{ width: "150px" }}
                  alt="Logo"
                  className="mb-10"
                />
                <h1
                  className=" text-dark mb-7"
                  style={{ fontSize: "30px", fontWeight: 600 }}
                >
                  Verify Expired!
                </h1>
                <div
                  className="text-gray-400 mb-10 text-muted fw-bold"
                  style={{ fontSize: "20px" }}
                >
                  Your Signup email verification link has been expired.
                </div>

                {/* <div className="text-center mb-10">
            <button
            id="kt_login_signin_submit"
            type="submit"
            className={`btn btn-diff-clr fw-bold px-9 py-4 my-3`}
            onClick={resendLink}
          >Resend</button>
						</div> */}

                <div className="text-center mb-10 ">
                  <button
                    id="kt_login_signin_submit"
                    type="submit"
                    className={`btn btn-diff-clr fw-bold px-9 py-4 my-3`}
                    onClick={resendLink}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
